import { FC } from "react";
import { ITicketInvoiceOnlyCancellation } from "../../interfaces/reservations/Reservations.types";

// Badge for a ticket already cancelled on the operator invoice. It is never undone from here:
// "Rikonfirmo rezervimin" on the booking is the only way back.
const TicketInvoiceCancelAction: FC<{ existing?: ITicketInvoiceOnlyCancellation }> = ({
  existing
}) =>
  existing ? (
    <span className="text-xs text-orange-700 font-medium" title={existing.reason || undefined}>
      {existing.consumed
        ? `Anuluar në faturë · faturuar (#${existing.id})`
        : `Anuluar në faturë (#${existing.id})`}
    </span>
  ) : null;

export default TicketInvoiceCancelAction;
